import {
  RemoteModuleInfo,
  RouteFilterProps,
  generateRouteConfig,
  getRemoteIconPath,
} from 'admin-web-utils'
import { kebabCase } from 'lodash'
import React from 'react'
import { SubAppContainer } from '../../components/SubAppContainer'
import { NewRouteDefinition } from '../../routes'

/**
 * Maps remote module information to routes that are consumable by the container.
 *
 * @param module the remote module to map
 * @param rootRoute the root route to be prepended to the mapped routes
 * @returns a RouteDefinition created from the provided remote module
 */
export const mapModuleToRoute = (
  module: RemoteModuleInfo,
  filterProps: RouteFilterProps,
): NewRouteDefinition => {
  const basePath = kebabCase(module.scope)
  const subAppContainerProps = {
    module: module.module,
    scope: module.scope,
    remoteUrl: module.remoteUrl,
  }

  return {
    ...generateRouteConfig(
      module.routeProps,
      filterProps,
      basePath,
      module.remoteUrl,
    ),
    element: <SubAppContainer key={module.scope} {...subAppContainerProps} />,
    remoteUrl: module.remoteUrl,
    iconPath: getRemoteIconPath(module.remoteUrl, module.routeProps.iconPath),
  } as NewRouteDefinition
}
